import { withLayout } from '../../HOC';
import React, {ReactElement, useEffect} from 'react';
import { Text } from '../../Component';
import styles from './ErrorScreen.styles';
import {AntDesign, Feather} from "@expo/vector-icons";
import {CareshipColors} from "../../Component/CSTheme";
import {FormattedMessage} from "react-intl";
import {cancelAllRelayRequests} from "../../../Infrastructure/Relay/InFlightRequestManager";
export default withLayout(function ErrorScreen(): ReactElement {
  useEffect(() => {
    // Cancel all in-flight Relay requests when this screen renders
    cancelAllRelayRequests();
  }, []);
  return (
      <>
        <Text style={{...styles.heading, color: CareshipColors.red}}>
          <AntDesign style={{ marginRight: 20 }} size={24} name="warning" />
          {' '}
          <FormattedMessage id="BOOKING_OR_CONTRACT_NOT_FOUND_ERROR"/>
        </Text>
        <Text style={{...styles.errorText, color: CareshipColors.red}}>
          <FormattedMessage id="BOOKING_OR_CONTRACT_NOT_FOUND_ERROR_MESSAGE"/>

        </Text>
      </>
  );
});
